'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { ErrorBoundary } from './ErrorBoundary';
import { Form } from './Form';
import { COMMODITIES } from './Form.content';
import styles from './LeadForm.module.scss';
export const LeadForm = ({ commodity, headline })=>/*#__PURE__*/ _jsx("section", {
        className: styles.container,
        id: COMMODITIES[commodity].id,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.content,
            children: [
                Boolean(headline) && /*#__PURE__*/ _jsx(Headline, {
                    align: "center",
                    renderAs: "h1",
                    size: "m",
                    children: headline
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.box,
                    children: /*#__PURE__*/ _jsx(ErrorBoundary, {
                        children: /*#__PURE__*/ _jsx(Form, {
                            commodity: commodity
                        })
                    })
                })
            ]
        })
    });

//# sourceMappingURL=LeadForm.js.map